import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../api/client';
import type { Stream } from '../api/types';
import { duration } from '../lib/format';
import { useApp } from '../stores/app';

const MODE_HINT: Record<string, string> = {
  direct: 'MediaMTX тянет источник сам, ffmpeg не запускается — доли процента ядра',
  'audio-only': 'Видео копируется, звук перекодируется в AAC — единицы процентов ядра',
  transcode: 'Транскод видео — от половины до полутора ядер на поток',
};

export function Streams() {
  const { tokenFilter, setTokenFilter, tokens, user } = useApp();
  const [items, setItems] = useState<Stream[]>([]);
  const [includeStopped, setIncludeStopped] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const load = async () => {
    try {
      const { items } = await api.streams(tokenFilter || undefined, includeStopped);
      setItems(items);
      setError(null);
    } catch (err) {
      setError((err as Error).message);
    }
  };

  useEffect(() => {
    void load();
    const timer = setInterval(() => void load(), 3000);
    return () => clearInterval(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tokenFilter, includeStopped]);

  const stop = async (key: string) => {
    await api.stopStream(key);
    void load();
  };

  const pin = async (key: string, pinned: boolean) => {
    await api.pinStream(key, pinned);
    void load();
  };

  return (
    <>
      <div className="topbar">
        <h1>Потоки</h1>
        <select className="shrink" style={{ width: 220 }} value={tokenFilter} onChange={(e) => setTokenFilter(e.target.value)}>
          <option value="">Все токены</option>
          {tokens.map((t) => (
            <option key={t.id} value={t.id}>
              {t.name}
            </option>
          ))}
        </select>
        <label className="shrink muted" style={{ display: 'flex', gap: 6, alignItems: 'center', fontSize: 12 }}>
          <input
            type="checkbox"
            style={{ width: 'auto' }}
            checked={includeStopped}
            onChange={(e) => setIncludeStopped(e.target.checked)}
          />
          показывать погашенные
        </label>
      </div>

      {error && <div className="panel error-text">{error}</div>}

      <div className="panel">
        <div className="table-wrap">
          <table>
            <thead>
              <tr>
                <th>Камера / объект</th>
                <th>Источник</th>
                <th>Статус</th>
                <th>Режим</th>
                <th>Параметры</th>
                <th className="num">Зрителей</th>
                <th className="num">Uptime</th>
                <th className="num">Рестартов</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {items.length === 0 && (
                <tr>
                  <td colSpan={9} className="muted">
                    Активных потоков нет. Поток поднимается при первом обращении зрителя по ссылке от Мажордома.
                  </td>
                </tr>
              )}
              {items.map((s) => (
                <tr key={s.key}>
                  <td>
                    <Link to={`/streams/${s.key}`}>{s.cam_ref ? `камера ${s.cam_ref}` : s.key}</Link>
                    {s.obj_ref && <div className="muted">объект {s.obj_ref}</div>}
                  </td>
                  <td className="wrap mono">{s.src_masked}</td>
                  <td>
                    <span className={`badge ${s.state}`}>{s.state}</span>
                    {s.pinned === 1 && <span className="badge warn" style={{ marginLeft: 4 }}>закреплён</span>}
                    {s.last_error && <div className="error-text mono" style={{ fontSize: 11 }}>{s.last_error.slice(0, 80)}</div>}
                  </td>
                  <td title={s.mode ? MODE_HINT[s.mode] : ''}>{s.mode ?? '—'}</td>
                  <td className="muted">
                    {s.video_codec ?? '?'} {s.width && s.height ? `${s.width}×${s.height}` : ''}{' '}
                    {s.fps ? `${s.fps} fps` : ''}
                    <div>
                      {s.has_audio ? (s.audio_codec ?? 'звук') : 'без звука'}
                      {s.gop_sec ? ` · GOP ${s.gop_sec} с` : ''}
                    </div>
                  </td>
                  <td className="num">{s.viewers}</td>
                  <td className="num">{duration(s.uptimeSec)}</td>
                  <td className="num">{s.restarts}</td>
                  <td>
                    {user?.role === 'admin' && (
                      <div style={{ display: 'flex', gap: 6 }}>
                        <button className="small" onClick={() => void pin(s.key, s.pinned !== 1)}>
                          {s.pinned === 1 ? 'Открепить' : 'Закрепить'}
                        </button>
                        <button className="small danger" onClick={() => void stop(s.key)}>
                          Погасить
                        </button>
                      </div>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}
